import React from "react";
import Avatar1 from "../../assets/images/xs/avatar1.jpg";
import Avatar2 from "../../assets/images/xs/avatar2.jpg";
import Avatar3 from "../../assets/images/xs/avatar3.jpg";
import Avatar4 from "../../assets/images/xs/avatar4.jpg";

function ReviewCommnetCard() {

    return (
        <ul className="list-unstyled mb-4 res-set">
            <li className="card mb-2">
                <div className="card-body p-lg-4 p-3">
                    <div className="d-flex mb-3 pb-3 border-bottom flex-wrap">
                        <img className="avatar rounded-circle" src={Avatar4} alt="" />
                        <div className="flex-fill ms-3 text-truncate">
                            <h6 className="mb-0"><span>Peter Allan</span> <span className="text-muted small">1050 Followers</span></h6>
                            <span className="text-muted">3 hours ago</span>
                        </div>
                        <div className="d-flex align-items-center">
                            <span className="mb-2 me-3">
                                <a href="#!" className="rating-link active"><i className="bi bi-star-fill text-warning"></i></a>
                                <a href="#!" className="rating-link active"><i className="bi bi-star-fill text-warning"></i></a>
                                <a href="#!" className="rating-link active"><i className="bi bi-star-fill text-warning"></i></a>
                                <a href="#!" className="rating-link active"><i className="bi bi-star-fill text-warning"></i></a>
                                <a href="#!" className="rating-link active"><i className="bi bi-star-half text-warning"></i></a>
                            </span>
                        </div>
                    </div>
                    <div className="timeline-item-post">
                        <h6 className="">The standard Lorem Ipsum passage, used since the 1500s</h6>
                        <p>"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p>
                        <div className="mb-2 mt-4 text-end">
                            <a className="me-lg-2 me-1 btn btn-primary btn-sm" href="#!"><i className="fa fa-thumbs-up"></i> <span className="d-none d-sm-none d-md-inline">Like (105)</span></a>
                            <a className="me-lg-2 me-1 btn btn-primary btn-sm" href="#!"><i className="fa fa-comment"></i> <span className="d-none d-sm-none d-md-inline">Publice Comment</span></a>
                            <a className="btn btn-primary btn-sm" href="#!"><i className="bi bi-chat-left-text-fill"></i> <span className="d-none d-sm-none d-md-inline">Direct Message</span></a>
                        </div>
                    </div>
                </div>
            </li>
            <li className="card mb-2">
                <div className="card-body p-lg-4 p-3">
                    <div className="d-flex mb-3 pb-3 border-bottom flex-wrap">
                        <img className="avatar rounded-circle" src={Avatar1} alt="" />
                        <div className="flex-fill ms-3 text-truncate">
                            <h6 className="mb-0"><span>Adrian Allan</span> <span className="text-muted small">650 Followers</span></h6>
                            <span className="text-muted">1 Day ago</span>
                        </div>
                        <div className="d-flex align-items-center">
                            <span className="mb-2 me-3">
                                <a href="#!" className="rating-link active"><i className="bi bi-star-fill text-warning"></i></a>
                                <a href="#!" className="rating-link active"><i className="bi bi-star-fill text-warning"></i></a>
                                <a href="#!" className="rating-link active"><i className="bi bi-star-fill text-warning"></i></a>
                                <a href="#!" className="rating-link active"><i className="bi bi-star-fill text-warning"></i></a>
                                <a href="#!" className="rating-link active"><i className="bi bi-star-half text-warning"></i></a>
                            </span>
                        </div>
                    </div>
                    <div className="timeline-item-post">
                        <h6 className="">The standard Lorem Ipsum passage, used since the 1500s</h6>
                        <p>"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p>
                        <div className="mb-2 mt-4 text-end">
                            <a className="me-lg-2 me-1 btn btn-primary btn-sm" href="#!"><i className="fa fa-thumbs-up"></i> <span className="d-none d-sm-none d-md-inline">Like (105)</span></a>
                            <a className="me-lg-2 me-1 btn btn-primary btn-sm" href="#!"><i className="fa fa-comment"></i> <span className="d-none d-sm-none d-md-inline">Publice Comment</span></a>
                            <a className="btn btn-primary btn-sm" href="#!"><i className="bi bi-chat-left-text-fill"></i> <span className="d-none d-sm-none d-md-inline">Direct Message</span></a>
                        </div>
                    </div>
                </div>
            </li>
            <li className="card mb-2">
                <div className="card-body p-lg-4 p-3">
                    <div className="d-flex mb-3 pb-3 border-bottom flex-wrap">
                        <img className="avatar rounded-circle" src={Avatar2} alt="" />
                        <div className="flex-fill ms-3 text-truncate">
                            <h6 className="mb-0"><span>Benjamin Keith</span> <span className="text-muted small">458 Followers</span></h6>
                            <span className="text-muted">5 Day ago</span>
                        </div>
                        <div className="d-flex align-items-center">
                            <span className="mb-2 me-3">
                                <a href="#!" className="rating-link active"><i className="bi bi-star-fill text-warning"></i></a>
                                <a href="#!" className="rating-link active"><i className="bi bi-star-fill text-warning"></i></a>
                                <a href="#!" className="rating-link active"><i className="bi bi-star-fill text-warning"></i></a>
                                <a href="#!" className="rating-link active"><i className="bi bi-star-fill text-warning"></i></a>
                                <a href="#!" className="rating-link active"><i className="bi bi-star-half text-warning"></i></a>
                            </span>
                        </div>
                    </div>
                    <div className="timeline-item-post">
                        <h6 className="">The standard Lorem Ipsum passage, used since the 1500s</h6>
                        <p>"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p>
                        <div className="mb-2 mt-4 text-end">
                            <a className="me-lg-2 me-1 btn btn-primary btn-sm" href="#!"><i className="fa fa-thumbs-up"></i> <span className="d-none d-sm-none d-md-inline">Like (105)</span></a>
                            <a className="me-lg-2 me-1 btn btn-primary btn-sm" href="#!"><i className="fa fa-comment"></i> <span className="d-none d-sm-none d-md-inline">Publice Comment</span></a>
                            <a className="btn btn-primary btn-sm" href="#!"><i className="bi bi-chat-left-text-fill"></i> <span className="d-none d-sm-none d-md-inline">Direct Message</span></a>
                        </div>
                        <div>
                            <div className="d-flex mt-3 pt-3 border-top">
                                <img className="avatar rounded-circle" src={Avatar3} alt="" />
                                <div className="flex-fill ms-3 text-truncate">
                                    <p className="mb-0"><span>Karen Clark</span> <small className="msg-time">5 Day ago</small></p>
                                    <span className="text-muted">"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span>
                                </div>
                            </div>
                        </div>
                        <div className="mt-4">
                            <textarea className="form-control" placeholder="Replay"></textarea>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    );
}


export default ReviewCommnetCard;